import React from 'react';
import { useTranslation } from 'react-i18next';
import ProductCard from './ProductCard';
import LoadingSpinner from '../UI/LoadingSpinner';

const CatalogGrid = ({ products, loading, error, searchTerm }) => {
  const { t } = useTranslation();
  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <div className="text-center">
          <p className="text-red-500 mb-2">{t('catalog.load_error')}</p>
          <p className="text-gray-600 text-sm">{error}</p>
        </div>
      </div>
    );
  }

  if (!products || products.length === 0) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <p className="text-gray-600">{t('catalog.no_products')}</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {products.map((product) => (
        <ProductCard key={product.id} product={product} searchTerm={searchTerm} />
      ))}
    </div>
  );
};

export default CatalogGrid;